/*
 * Copyright (c) 2017 Datarista, Inc.
 */

/* eslint-disable consistent-return */

import { polyfill } from 'es6-promise';
import { startAction, completeAction, handleError, reportSuccess } from './common';
import { accountServiceClient } from '../utils/api';

polyfill();

export const actionTypes = {
  PLATFORM_USE_CASE_SUBSCRIBE_SUCCESS: 'PLATFORM_USE_CASE_SUBSCRIBE_SUCCESS',
  PLATFORM_USE_CASE_UNSUBSCRIBE_SUCCESS: 'PLATFORM_USE_CASE_UNSUBSCRIBE_SUCCESS',
  PLATFORM_USE_CASE_SUBSCRIBE_ERROR: 'PLATFORM_USE_CASE_SUBSCRIBE_ERROR',
  PLATFORM_USE_CASE_SUBSCRIBED_FETCH_SUCCESS: 'PLATFORM_USE_CASE_SUBSCRIBED_FETCH_SUCCESS',
  USE_CASES_FETCH_SUCCESS: 'USE_CASES_FETCH_SUCCESS',
};

// Connect to the API
const swaggerApi = accountServiceClient();

// Action - Platform Use case subscribe Success
const platformUseCaseSubscribeSuccess = accountPlatformUseCases => ({
  type: actionTypes.PLATFORM_USE_CASE_SUBSCRIBE_SUCCESS,
  accountPlatformUseCases,
});

export function subscribePlatformUseCase(accountId, token, platformUseCaseRequest) {
  const actionText = 'Subscribe account to platform use case';

  return dispatch => {
    startAction(dispatch, actionText);
    return swaggerApi.then(client => {
      client.accounts
        .addAccountPlatformUseCases({
          Authorization: `bearer ${token}`,
          account_id: accountId,
          body: {
            platformCode: platformUseCaseRequest.platformCode,
            useCaseCode: platformUseCaseRequest.useCaseCode,
          },
        })
        .then(response => {
          // If everything's cool, dispatch actions
          if (response.status >= 200 && response.status < 300) {
            const platformUseCasesInfo = response.obj;
            dispatch(platformUseCaseSubscribeSuccess(platformUseCasesInfo));
            reportSuccess(dispatch, 'Subscribed successfully', null);
            completeAction(dispatch, actionText);
          } else {
            return Promise.reject(response);
          }
        })
        .catch(err => {
          handleError(err, dispatch, actionText);
        });
    });
  };
}

// Action - Platform Use case un-subscribe Success
const platformUseCaseUnSubscribeSuccess = accountPlatformUseCases => ({
  type: actionTypes.PLATFORM_USE_CASE_UNSUBSCRIBE_SUCCESS,
  accountPlatformUseCases,
});

export function unSubscribePlatformUseCase(accountId, token, platformUseCaseRequest) {
  const actionText = 'Un-subscribe account from platform use case';

  return dispatch => {
    startAction(dispatch, actionText);
    return swaggerApi.then(client => {
      client.accounts
        .removeAccountPlatformUseCases({
          Authorization: `bearer ${token}`,
          account_id: accountId,
          platform_code: platformUseCaseRequest.platformCode,
          use_case_code: platformUseCaseRequest.useCaseCode,
        })
        .then(response => {
          // If everything's cool, dispatch actions
          if (response.status >= 200 && response.status < 300) {
            const platformUseCasesInfo = response.obj;
            dispatch(platformUseCaseUnSubscribeSuccess(platformUseCasesInfo));
            reportSuccess(dispatch, 'Un-subscribed successfully', null);
            completeAction(dispatch, actionText);
          } else {
            return Promise.reject(response);
          }
        })
        .catch(err => {
          handleError(err, dispatch, actionText);
        });
    });
  };
}

const platformUseCaseSubscribedFetchSuccess = accountPlatformUseCases => ({
  type: actionTypes.PLATFORM_USE_CASE_SUBSCRIBED_FETCH_SUCCESS,
  accountPlatformUseCases,
});

// Fetch subscribed platform use cases for logged in account
export function getSubscribedPlatformUseCases(accountId, token) {
  const actionText = 'Fetching subscribed platform use cases';
  return dispatch => {
    startAction(dispatch, actionText);
    return swaggerApi.then(client => {
      client.accounts
        .getAccountPlatformUseCases({
          Authorization: `bearer ${token}`,
          account_id: accountId,
        })
        .then(response => {
          // If everything's cool, dispatch actions
          if (response.status >= 200 && response.status < 300) {
            const platformUseCasesInfo = response.obj;
            dispatch(platformUseCaseSubscribedFetchSuccess(platformUseCasesInfo));
            completeAction(dispatch, actionText);
          } else {
            return Promise.reject(response);
          }
        })
        .catch(err => {
          handleError(err, dispatch, actionText);
        });
    });
  };
}

const useCasesFetchSuccess = useCases => ({
  type: actionTypes.USE_CASES_FETCH_SUCCESS,
  useCases,
});

// Retrieve all use cases
export function getAllUseCases(token) {
  const actionText = 'Fetching all use cases';
  return dispatch => {
    startAction(dispatch, actionText);
    return swaggerApi.then(client => {
      client.platform_use_case
        .getAllUseCases({
          Authorization: `bearer ${token}`,
        })
        .then(response => {
          // If everything's cool, dispatch actions
          if (response.status >= 200 && response.status < 300) {
            const useCasesInfo = response.obj;
            dispatch(useCasesFetchSuccess(useCasesInfo));
            completeAction(dispatch, actionText);
          } else {
            return Promise.reject(response);
          }
        })
        .catch(err => {
          handleError(err, dispatch, actionText);
        });
    });
  };
}
